import React from 'react';
import './ConfirmationPage.css';

const ConfirmationPage = ({ reservationDetails }) => {
  // Format the date to be more readable
  const formatDate = (dateString) => {
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  return (
    <div className="confirmation-container">
      <div className="confirmation-content">
        <div className="confirmation-header">
          <span className="checkmark">✓</span>
          <h1>Reservation Confirmed!</h1>
          <p>Thank you for choosing Little Lemon</p>
        </div>

        <div className="reservation-details">
          <h2>Your Reservation Details</h2>
          <div className="details-grid">
            <div className="detail-item">
              <span className="detail-label">Date:</span>
              <span className="detail-value">{formatDate(reservationDetails.date)}</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Time:</span>
              <span className="detail-value">{reservationDetails.time}</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Guests:</span>
              <span className="detail-value">{reservationDetails.guests} {reservationDetails.guests === 1 ? 'Guest' : 'Guests'}</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Occasion:</span>
              <span className="detail-value">{reservationDetails.occasion}</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Name:</span>
              <span className="detail-value">{reservationDetails.name}</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Email:</span>
              <span className="detail-value">{reservationDetails.email}</span>
            </div>
            {reservationDetails.specialRequests && (
              <div className="detail-item full-width">
                <span className="detail-label">Special Requests:</span>
                <span className="detail-value">{reservationDetails.specialRequests}</span>
              </div>
            )}
          </div>
        </div>

        <div className="confirmation-actions">
          <button className="action-button primary">Add to Calendar</button>
          <button className="action-button secondary">Print Confirmation</button>
        </div>

        <div className="next-steps">
          <h3>Next Steps</h3>
          <ul>
            <li>You will receive a confirmation email shortly</li>
            <li>Please arrive 5 minutes before your reservation time</li>
            <li>Call us at (555) 123-4567 if you need to make any changes</li>
            <li>Check out our menu to plan your meal</li>
          </ul>
        </div>

        <div className="restaurant-info">
          <h3>Little Lemon Restaurant</h3>
          <p>123 Mediterranean Street</p>
          <p>Chicago, IL 60601</p>
          <p>Phone: (555) 123-4567</p>
          <p>Email: reservations@littlelemon.com</p>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPage;